async function initProductSwiperElements() {
  if (!('Swiper' in window)) {
    return;
  }
  document.querySelectorAll('.product-swiper:not(.swiper--initialized)').forEach(async (swiperElement) => {
    swiperElement.classList.add('swiper--initialized');

    let previousButtonElement = null;
    if ('previousButtonId' in swiperElement.dataset) {
      previousButtonElement = document.getElementById(swiperElement.dataset.previousButtonId);
    }
    let nextButtonElement = null;
    if ('nextButtonId' in swiperElement.dataset) {
      nextButtonElement = document.getElementById(swiperElement.dataset.nextButtonId);
    }

    if ('relatedProductId' in swiperElement.dataset) {
      await loadProductSwiperElementRelatedProducts(swiperElement);
      if (swiperElement.querySelectorAll('.swiper-slide').length > 0) {
        swiperElement.closest('.product-swiper-related-products--hidden').classList.remove('product-swiper-related-products--hidden');
      }
    }

    const swiperSettings = {
      slidesPerView: 1.2,
      spaceBetween: 16,
      breakpoints: {
        414: {
          slidesPerView: 1.33,
          spaceBetween: 16
        },
        713: {
          slidesPerView: 2.33,
          spaceBetween: 16
        },
        1012: {
          slidesPerView: 3.33,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1268: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      },
      speed: 400,
      mousewheel: {
        forceToAxis: true
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      on: {
        scrollbarDragEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        scrollbarDragStart: function(swiper, event) {
          document.body.classList.add('body--grabbing');
        },
        slideChange: function(swiper) {
          if (previousButtonElement !== null) {
            if (swiper.activeIndex === 0) {
              previousButtonElement.classList.add('product-swiper-button--disabled');
            } else {
              previousButtonElement.classList.remove('product-swiper-button--disabled');
            }
          }
          if (nextButtonElement !== null) {
            if (swiper.activeIndex === swiper.slides.length - swiper.slidesPerViewDynamic()) {
              nextButtonElement.classList.add('product-swiper-button--disabled');
            } else {
              nextButtonElement.classList.remove('product-swiper-button--disabled');
            }
          }
        },
        touchEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        touchStart: function(swiper, event) {
          if (swiper.slides.length <= swiper.slidesPerViewDynamic()) {
            return;
          }
          document.body.classList.add('body--grabbing');
        }
      }
    };

    if (swiperElement.dataset.blockIndex === 'cart-sidebar') {
      delete swiperSettings.breakpoints;
    }

    const swiper = new Swiper(swiperElement, swiperSettings);

    if (previousButtonElement !== null) {
      previousButtonElement.addEventListener('click', () => {
        swiper.slidePrev();
      });
    }

    if (nextButtonElement !== null) {
      nextButtonElement.addEventListener('click', () => {
        swiper.slideNext();
      });
    }
  });
}


async function loadProductSwiperElementRelatedProductsInnerHTML(relatedProductId) {
  const response = await fetch(window.Shopify.routes.root + 'recommendations/products?product_id=' + relatedProductId + '&section_id=product-recommendations&intent=related');
  const responseText = await response.text();
  const wrapper = document.createElement('div');
  wrapper.innerHTML = responseText;
  return wrapper.querySelector('.shopify-section').innerHTML;
}


async function loadProductSwiperElementRelatedProducts(swiperElement) {
  const relatedProductIds = swiperElement.dataset.relatedProductId.split(',');
  const innerHTMLs = await Promise.all(relatedProductIds.map((relatedProductId) => {
    return loadProductSwiperElementRelatedProductsInnerHTML(relatedProductId);
  }));
  const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');
  swiperWrapper.innerHTML = innerHTMLs.join('');
  if (swiperWrapper.closest('#shopify-section-cart-sidebar') !== null) {
    if (swiperWrapper.querySelectorAll('.swiper-slide').length === 0) {
      document.querySelector('#shopify-section-cart-sidebar .collection-block').style.display = 'none';
      if (swiperWrapper.closest('.cart-sidebar') !== null) {
        document.querySelector('.cart-sidebar #shopify-section-cart-items').style.marginBottom = '246px';
      } else {
        document.querySelector('#shopify-section-cart-sidebar .cart-page__sidebar-inner').style.marginTop = '0';
      }
    } else {
      document.querySelector('#shopify-section-cart-sidebar .collection-block').style.display = 'flex';
      if (swiperWrapper.closest('.cart-sidebar') !== null) {
        document.querySelector('.cart-sidebar #shopify-section-cart-items').style.marginBottom = '476px';
      } else {
        document.querySelector('#shopify-section-cart-sidebar .cart-page__sidebar-inner').style.marginTop = '32px';
      }
    }
  }
  initProductCardElements();
}



window.addEventListener('load', (event) => {
  initProductSwiperElements();
});


if (document.readyState !== 'loading') {
  initProductSwiperElements();
} else {
  window.addEventListener('DOMContentLoaded', initProductSwiperElements);
}
